import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {sortBy, map, filter} from 'lodash-es';
import {AppConfigService} from '../../../services/app.config.service';

@Component({
  selector: 'impacted-parties-tld-list',
  templateUrl: './impacted-parties-tld-list.component.html',
  styleUrls: ['./impacted-parties-tld-list.component.scss']
})
export class ImpactedPartiesTldListComponent implements OnInit {

  @Input()
  domains: any;

  @Input()
  currentDomainName: string;

  domainNameId: any[] = [];

  constructor(private appConfigService: AppConfigService, private router: Router) {
  }

  ngOnInit(): void {
    this.domainNameId = sortBy(filter(map(this.domains, (key, value) => ({name: key, id: value }))
        , (item) => (item.name !== this.currentDomainName))
        , ['name']);
  }

  navigateToViewDomain(domainId: string) {
    if (this.appConfigService.config.interfaceType === 'STAFF') {
      this.router.navigateByUrl(`/domain/view/` + domainId);
    }
  }
}
